import React, { useState, useEffect, useCallback } from "react";
import { Helmet } from "react-helmet";
import OptimizedImage from "./OptimizedImage";
                  
import "../pages/styles/carousel.css";

// Import optimized images - using smaller versions for better performance
// For LCP image (5.webp), we'll use the public folder version to control sizing
import img2 from "../assets/images/2.webp";
import img3 from "../assets/images/3.webp";
import img4 from "../assets/images/4.webp";
import img5 from "../assets/images/1.webp";

// Move partners array outside the component to avoid re-creation on every render
const partners = [
  { 
    id: 1, 
    src: process.env.PUBLIC_URL + "/5.webp", // Use public folder for responsive image
    srcSet: `${process.env.PUBLIC_URL}/5.webp 1200w`,
    sizes: "(max-width: 768px) 100vw, 800px",
    alt: "HR Course promotional image, showcasing professional development opportunities." 
  },
  { id: 2, src: img2, alt: "Book Now - Call to action for scheduling courses." },
  { id: 3, src: img3, alt: "Programs Overview - A variety of educational programs offered." },
  { id: 4, src: img4, alt: "GAT Tests - Preparing for Graduate Admission Tests with expert resources." },
  { id: 5, src: img5, alt: "HR Diploma - Image showcasing the HR Diploma certification program." },
];

const PartnerCarousel = () => {
  const [current, setCurrent] = useState(0);
  const total = partners.length;

  const goToPrev = useCallback(() => setCurrent((prev) => (prev === 0 ? total - 1 : prev - 1)), [total]);
  const goToNext = useCallback(() => setCurrent((prev) => (prev === total - 1 ? 0 : prev + 1)), [total]);

  // Auto-scroll functionality
  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 10000); // Change slide every 4 seconds

    return () => clearInterval(interval);
  }, [goToNext]);

  return (
    <section className="partner-carousel" aria-labelledby="partner-carousel-heading">
      <Helmet>
        <link
          rel="preload"
          as="image"
          href={process.env.PUBLIC_URL + "/5.webp"}
          fetchpriority="high"
          type="image/webp"
        />
      </Helmet>
      <div className="carousel-container">
        <div className="carousel-wrapper">
          <button
            className="carousel-arrow carousel-arrow-left"
            onClick={goToPrev}
            aria-label="Previous slide"
          >
            &#8249;
          </button>
          
          <div className="carousel-slide">
            <OptimizedImage
              src={partners[current].src}
              srcSet={partners[current].srcSet}
              alt={partners[current].alt}
              className="carousel-image"
              priority={current === 0}
              width="1200"
              height="500"
              sizes={partners[current].sizes || "(max-width: 768px) 100vw, 1200px"}
              decoding={current === 0 ? "sync" : "async"}
            />
          </div>
          
          <button
            className="carousel-arrow carousel-arrow-right"
            onClick={goToNext}
            aria-label="Next slide"
          >
            &#8250;
          </button>
        </div>
        
        {/* Dots indicator */}
        <div className="carousel-dots">
          {partners.map((_, idx) => (
            <button
              key={idx}
              className={`carousel-dot ${idx === current ? 'active' : ''}`}
              onClick={() => setCurrent(idx)}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerCarousel;